import script from "./MultifileUploader.vue?vue&type=script&setup=true&lang=js"
export * from "./MultifileUploader.vue?vue&type=script&setup=true&lang=js"

import "./MultifileUploader.vue?vue&type=style&index=0&id=430038dc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-430038dc"]])

export default __exports__